import { SubscriberViewModel } from '../../shared/models/subscriberViewModel';
import { IncidentItemViewModel } from './incidentItemViewModel';

export class IncidentListItemViewModel extends IncidentItemViewModel {
  attachmentsCount: number;
  subscribers?: SubscriberViewModel[];
  isSelected: boolean;
}
